import { navigateInApp, opensPagesInSameTab, sameTabPath } from "./sameTabNavigation";

export default function openInNewTab(url) {
  // Roles can opt out of new tabs; other sites still always open in one.
  const path = opensPagesInSameTab() ? sameTabPath(url, window.location.origin) : null;
  if (path && navigateInApp(path)) return;
  window.open(url, "_blank", "noopener, noreferrer");
}
